// extracted by mini-css-extract-plugin
export default {"loadingDots":"YlZPmr","dot":"pPJ584","dotPulse":"NQu3Vh"};